import React, { Component } from 'react'
import PropTypes from 'prop-types'

import HeaderPage from './../block/HeaderPage'
import Breadcrumbs from './../block/Breadcrumbs'
import ShopsNg from './../block/ShopsNg'
import QwestionsNg from './../block/QwestionsNg'

import { Container, Row, Col, Image } from 'react-bootstrap'

import styles from './../blocks.module.sass'

export default class Main extends Component {

  render() {

    const { ajax_data, page_data, changeTopSearch, changeLeftMenuh, favorite, cart } = this.props

    return (
      <>
        <div className='w-100' style={{ flex: 1 }}>
          <HeaderPage
            ajax_data={ajax_data}
            page_data={page_data}
            changeTopSearch={changeTopSearch}
            changeLeftMenuh={changeLeftMenuh}
            favorite={favorite}
            cart={cart}
          />
          {ajax_data != null &&
            <>
              <Breadcrumbs
                pages={[
                  {
                    name: ajax_data.pagetitle,
                    current: true
                  }
                ]}
              />
              <div className={styles.oplata_i_dostavka}>
                <Container>
                  <h1 className={styles.oplata_i_dostavka_iptitle}>{ajax_data.seo_h1}</h1>
                  <Row>
                    <Col xl={6}>
                      <div className={styles.oplata_i_dostavka_text} dangerouslySetInnerHTML={{__html: ajax_data.content}}></div>
                    </Col>
                    <Col xl={6}>
                      <Image className={`d-none d-sm-block h-auto mx-auto me-xl-0 ms-xl-auto mt-5 mt-xl-0`} src={ajax_data.image} width="565" height="610" />
                      <Image className={`d-sm-none w-100 h-auto mt-4`} src={ajax_data.image_mob} width="355" height="512" />
                    </Col>
                  </Row>
                </Container>
              </div>
            </>
          }
          <ShopsNg
            page_data={page_data}
            ajax_data={ajax_data}
          />
          <QwestionsNg
            ajax_data={ajax_data}
          />
        </div>
      </>
    )
  }
}

Main.propTypes = {
  ajax_data: PropTypes.object,
  page_data: PropTypes.object,
  search: PropTypes.string,
  changeSearch: PropTypes.func,
  changeTopSearch: PropTypes.func,
  changeLeftMenuh: PropTypes.func,
  showInCart: PropTypes.func,
  favorite: PropTypes.array,
  changeFavorite: PropTypes.func,
  cart: PropTypes.array,
  in_cart_loading: PropTypes.bool
}